import { useEffect, useState } from 'react';
import call_icon from '../assets/call_white.svg';
import chat_icon from '../assets/chat_icon.svg';
import chat_icon_white from '../assets/chat_icon_white.svg'
import done from '../assets/done.svg';
import Button from '../components/Button/Button';
import { gql, useMutation } from '@apollo/client';
import HubLocations from '../components/HubLocations';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { PHONE_NUMBER } from '../constants';
declare global {
  interface Window {
    grecaptcha: any;
  }
}

function CustomerSupport() {
  let { t } = useTranslation();
  const CUSTOMER_SUPPORT_FORM = gql`
    mutation CustomerSupport($customerSupportData: CustomerSupportInput!) {
      customerSupport(customerSupportData: $customerSupportData) {
        success
        message
      }
    }
  `;
  let [
    submitForm,
    { data: submitFormRes, loading: submitFormLoading, error: submitFormError },
  ] = useMutation(CUSTOMER_SUPPORT_FORM);

  if (submitFormError) {
    console.log(submitFormError);
  }

  let handleContactUsSubmit = async (e: any) => {
    e.preventDefault();

    let data: any = {
      email: e.target.elements.email.value,
      order_no: e.target.elements.orderNo.value,
      message: e.target.elements.message.value,
    };


    // Retreive Captcha Token
    await window.grecaptcha.ready((_: any) => {
      window.grecaptcha
        .execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, {
          action: 'login',
        })
        .then((token: any) => {
          data['captchaToken'] = token;
          submitForm({
            variables: {
              customerSupportData: data,
            },
          });
        });
    });
  };

  const handleLoaded = (_: any) => {
    window.grecaptcha.ready((_: any) => {
      window.grecaptcha
        .execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, {
          action: 'login',
        })
        .then((token: any) => {});
    });
  };

  const [isChatOpen, setIsChatOpen] = useState(false);

  const toggleChat = () => {
    setIsChatOpen((prev) => !prev);
  };

  useEffect(() => {
    // Add reCaptcha
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
    script.addEventListener('load', handleLoaded);
    document.body.appendChild(script);
  }, []);
  return (
    <>
      <Helmet>
        <title>Customer Support | MeraPashu360</title>

        <meta
          name="description"
          content="Download the Merapashu360 app from the Play Store today or call our customer helpline number: 7065360360📲"
        />
        <link rel="canonical" href="https://merapashu360.com/contact-us/" />
      </Helmet>
      <div className="c_us__linearbg">
        <div className="c_us__container">
          <div className="c_us__heading">
            <p className="subheading">{t("support_us_sub")}</p>
            <p className="heading">{t("contact_us_title")}</p>
          </div>

          <div className="c_us__ctas">
          <a href={`tel:${PHONE_NUMBER}`} className="c_us__cta" style={{ textDecoration: "none" }}>
            <img src={call_icon} alt="call icon" />
            <p className="white">{t("get_query_solved")}</p>
            <p className="heading white">{PHONE_NUMBER}</p>
          </a>

            <div className="c_us__cta" onClick={toggleChat}>
              <img src={chat_icon} alt="chat icon" style={{paddingBottom:"8px"}} />
              <p>{t("chat_with_ai")}</p>
            </div>
          </div>

          <div className="c_us__location-form">

            <div className="c_us__form">
              <p className="heading">{t("contact_us")}</p>
              {!submitFormRes?.customerSupport?.success ? (
                <form onSubmit={(e) => handleContactUsSubmit(e)}>
                  <label htmlFor="email">{t("email")} </label> <br />
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="abc@gmail.com"
                    required
                  />{" "}
                  <br />
                  <label htmlFor="orderNo">{t("order_number")}</label> <br />
                  <input
                    type="text"
                    id="orderNo"
                    name="orderNo"
                    placeholder="Order Number"
                    required
                  />{" "}
                  <br />
                  <label htmlFor="message">{t("message")}</label> <br />
                  <textarea
                    required
                    id="message"
                    name="message"
                    cols={24}
                    rows={6}
                  />{" "}
                  <br />
                  <div className="termsConditions">
                    <input type="checkbox" id="checkbox" required defaultChecked
                    style={{
                      width:"6%",
                      boxShadow:"none",
                      height:"20%"

                     }} />
                    <label className="checkbox" htmlFor="checkbox" style={{ fontSize:"14px"}}>
                      {" "}
                      I agree to all the     {" "}
                      <a href="https://merapashu360.com/terms-of-service">
                        Terms and Conditions
                      </a>
                      .
                    </label>
                  </div>
                  <br />
                  <Button
                    primary
                    rightArrow
                    text={
                      submitFormLoading ? t("submitting") : t("submit_form")
                    }
                    disabled={submitFormLoading}
                  />
                </form>
              ) : (
                <div className="c_us__thankyou">
                  <img src={done} alt="Done" />
                  <p className="c_us__heading">
                    Thank you for submitting the form
                  </p>
                  <p className="c_us__sub">
                    Our team will get back to you soon
                  </p>

                  <div className="c_us__thankyou-button">
                    <Button
                      text="SUBMIT ANOTHER FORM"
                      primary
                      rightArrow
                      to="/customer-support"
                    />
                  </div>
                </div>
              )}
            </div>
            {/*Chat Window */}
            <div className="chat-container">
              {!isChatOpen ? (
                <div className="floating-icon" onClick={toggleChat}>
                  <img src={chat_icon_white} alt="Chat" />
                </div>
              ) : (
                <div className="chat-popup">
                  <button className="chat-close" onClick={toggleChat}>✖</button>
                  <iframe src="/yap" className="chat-iframe" scrolling="no" />
                </div>
              )}
            </div>

          </div>
        </div>
      </div>

      <HubLocations />
    </>
  );
}

export default CustomerSupport;
